import { Link } from "react-router-dom";

export function AuthLegalLinks() {
  return (
    <p className="text-xs text-slate-400 text-center mt-6">
      <Link to="/privacy" className="text-slate-500 hover:text-emerald-700 underline-offset-2 hover:underline">
        Privacy Policy
      </Link>
    </p>
  );
}
